import {calculateEndpointType} from './common';

/**
 * Provides base URL for calling embodee services and requesting images/inspirations (i.e. on the Gridwall)
 *
 * Non-prod uniforms are served from Embodee dev (STG/QA carts reference nike-dev.embodee.com image URLs).
 * TODO: Add a new endpoint type for prod uniforms (i.e. builder.nike.com)
 */
const endpointTypeToUrl = {
  local: 'https://nike-dev.embodee.com/',
  dev: 'https://nike-dev.embodee.com/',
  qa: 'https://nike-dev.embodee.com/',
  stg: 'https://nike-dev.embodee.com/',
  uat: 'https://nike-dev.embodee.com/',
  prod: 'https://builder.nike.com/'
};

export default function embodeeBuilderBaseUrl(location) {
  const type = calculateEndpointType(location, 'prod');
  return endpointTypeToUrl[type];
}
